import React, { ReactNode } from "react";
import RadioGroupContext from "./RadioGroupContext";

// /// Context provider displayname
// RadioGroupContext.Provider.displayName = "RadioGroupProvider";

/**
 * @description RadioGroupItem UI Properties
 *
 * @interface IRadioGroupItemProps
 */
interface IRadioGroupItemProps {
  /**
   * @description Button Group 이름
   */
  name?: string;
  /**
   * @description 선택된 라디오 버튼 값 정의
   */
  selectedValue?: string;
  /**
   * @description 클래스 이름
   */
  className: string;
  /**
   * @description React 자식 노드들
   */
  children: ReactNode;
  /**
   * @description 저장 데이터(필요시 활용)
   */
  disabled?: boolean;
  /**
   * @description Radio Group에서 Radio 버튼 선택 변경에 대한 이벤트 발생시 호출되는 Callback 함수
   */
  onChange?: ((key: string, value: string) => void) | null;
}

/**
 * @description RadioGroupItem UI States
 *
 * @interface IRadioGroupItemState
 */
interface IRadioGroupItemState {
  selectedValue: string;
}

/**
 * @description Radio Group 과 동일한 기능을 하는 ContextMenu item UI 컴포넌트 구현
 *
 * @class RadioGroupItem
 * @extends {React.Component}
 */
class RadioGroupItem extends React.Component<
  IRadioGroupItemProps,
  IRadioGroupItemState
> {
  /**
   * @description Default property 값 정의
   * @static
   * @memberof RadioGroupItem
   */
  public static defaultProps = {
    name: "",
    selectedValue: "",
    className: "",
    disabled: false,
    onChange: () => {}
  };
  /**
   * Creates an instance of RadioGroupItem.
   * @param {*} props
   * @memberof RadioGroupItem
   */
  constructor(props: any) {
    super(props);
    this.state = {
      selectedValue: props.selectedValue
    };
  }
  componentDidUpdate() {
    (this.state.selectedValue as any) = this.props.selectedValue;
  }
  /**
   * @method render
   * @description RadioGroup에 속하는 RadioButtonItem을 렌더링하고, Provider context를 전달
   * @returns
   * @memberof RadioGroupItem
   */
  render() {
    const { name, onChange, children, disabled, className } = this.props;
    //const { selectedValue } = this.state;
    const { selectedValue } = this.props;

    /**
     * @function updateValue
     * @description 선택된 라디오 버튼의 값을 저장하고, onChange 함수를 callback
     * @param {*} key
     * @param {*} value
     */
    const updateValue = (key: any, value: any) => {
      if (onChange && typeof onChange === "function") {
        onChange(key, value);
      }
      /// 선택된 라디오 버튼 값 저장 및 렌더링
      this.setState({ selectedValue: value });
    };
    return (
      <React.Fragment>
        <RadioGroupContext.Provider
          value={{
            selectedValue,
            onChange,
            name,
            disabled,
            className,
            updateValue
          }}
        >
          {children}
        </RadioGroupContext.Provider>
      </React.Fragment>
    );
  }
}

export default RadioGroupItem;
